import { connect } from 'react-redux';

import UpdateDeviceModal from './UpdateDeviceModal';
import { findPreactivation } from 'actions/preactivations';
import { updateDevice, findQuickSub } from 'actions/quickSubs';
import { getIsAdmin, getPreactivation } from 'reducers';

const mapStateToProps = (state, { sub }) => {
  let preactivationId = sub && sub.preactivation;
  return {
    preactivation: preactivationId && getPreactivation(state, preactivationId),
    preactivationId,
    isQuick: true,
    isAdmin: getIsAdmin(state),
  };
};

const mapDispatchToProps = {
  updateDevice: updateDevice,
  findSub: findQuickSub,
  findPreactivation: findPreactivation,
};

const UpdateSimoDeviceModal = connect(
  mapStateToProps,
  mapDispatchToProps,
)(UpdateDeviceModal);

export default UpdateSimoDeviceModal;
